import React, { useState } from 'react';
import {observer} from "mobx-react-lite";
import Seo from "../components/Seo";
import Platforms from "../components/Index/Technology";
import NewGames from "../components/Index/NewGames";
import MainGame from "../components/Index/MainGame";
import AboutUs from "../components/Index/AboutUs";
import Header from "../components/Header";
import Footer from "../components/Footer";
import 'pepjs'

const IndexPage = () => {
    const [loading, setLoading] = useState(false);

    return (
        <>
            <Seo page='index'  />
            <div className="main background">
                <Header />
                <MainGame loading={loading} setLoading={setLoading} />
                {loading && <section className="details_content content">
                    <NewGames/>
                    <AboutUs/>
                    <Platforms/>
                    <Footer/>
                </section>}
            </div>
        </>
    );
};

export default observer(IndexPage);